import React from "react";
import { Button, Form, Stack } from "react-bootstrap";
import NavigasiBar from "./NavigasiBar";

const FormPage = (
  {
    email,  
    name,
    password,
    count,
    isPasswordError,
    handleChange,
    handleSubmit
  }
) => {
  return (
    <Stack gap={2}>
        <NavigasiBar/>
        <h2>Form Page</h2>
        <span className="display-6">{count}</span>
        <Form onSubmit={handleSubmit}>
            {/* Name */}
            <Form.Group className="mb-3 d-flex flex-column align-items-start">
                <Form.Label>Name</Form.Label>
                <Form.Control
                    name="name"
                    type="text"
                    value={name}
                    onChange={(ev) => handleChange(ev)}
                    required
                    placeholder="ex: David Nasrulloh"
                />
            </Form.Group>
            {/* Email Address */}
            <Form.Group className="mb-3 d-flex flex-column align-items-start">
                <Form.Label>Email Address</Form.Label>
                <Form.Control
                    name="email"
                    type="email"
                    value={email}
                    onChange={(ev) => handleChange(ev)}
                    required
                    placeholder="ex: blabla@gmail.com"
                />
            </Form.Group>
            {/* Password */}
            <Form.Group className="mb-3 d-flex flex-column align-items-start" >
                <Form.Label>Password</Form.Label>
                <Form.Control
                    name="password"
                    type="password"
                    value={password}
                    required
                    onChange={(ev) => handleChange(ev)}
                />
                {
                isPasswordError && (
                    <Form.Text className="text-error">
                        Password tidak sesuai yang diinginkan. Password harus lebih dari 5 karakter
                    </Form.Text>
                )
                }
            </Form.Group>
            {/* Gender */}
            <Form.Group className="mb-3 d-flex flex-column align-items-start">
                <Form.Label>Gender</Form.Label>
                <Stack gap={2} direction="horizontal">
                    <Form.Check
                        name="gender"
                        type="radio"
                        value="L"
                        label="Laki - Laki"
                        onChange={(ev) => handleChange(ev)}
                        required
                    />
                    <Form.Check
                        name="gender"
                        type="radio"
                        value="P"
                        label="Perempuan"
                        onChange={(ev) => handleChange(ev)}
                        required
                    />
                </Stack>
            </Form.Group>
            {/* Hobby */}
            <Form.Group className="mb-3 d-flex flex-column align-items-start"
                onChange={(ev) => handleChange(ev)}>
                <Form.Label>Hobby</Form.Label>
                <Stack gap={2} direction="horizontal">
                    <Form.Check
                        name="hobby"
                        type="checkbox"
                        value="makan"
                        label="Makan"
                        onChange={(ev) => handleChange(ev)}
                    />
                    <Form.Check
                        name="hobby"
                        type="checkbox"
                        value="membaca"
                        label="Membaca"
                        onChange={(ev) => handleChange(ev)}
                    />
                    <Form.Check
                        name="hobby"
                        type="checkbox"
                        value="ngoding"
                        label="Ngoding"
                        onChange={(ev) => handleChange(ev)}
                    />
                    <Form.Check
                        name="hobby"
                        type="checkbox"
                        value="tidur"
                        label="Tidur"
                        onChange={(ev) => handleChange(ev)}
                    />
                </Stack>
            </Form.Group>
            <Button variant="success" type="submit" disabled={isPasswordError}>
                Submit
            </Button>
        </Form>
    </Stack>
    )
}

export default FormPage;
